<template>
    <Map class="animated fadeIn" type="Nước dưới đất" config-key="nuoc_duoi_dat" />
</template>

<script>
import Map from '@/components/Map';

export default {
    components: {
        Map
    }
};
</script>
